"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.connectSupportMethods = void 0;
exports.creatNotSupportMethodItemReplay = creatNotSupportMethodItemReplay;
exports.isMobileDiscover = isMobileDiscover;
exports.connectMethodsAdaptOldVersion = connectMethodsAdaptOldVersion;
exports.connectMethodsResponseUpdate = connectMethodsResponseUpdate;
exports.connectMethodsToConnectWalletMethods = connectMethodsToConnectWalletMethods;
exports.syncResoonseToRequire = syncResoonseToRequire;
const core_1 = require("@okxconnect/core");
const bs58_1 = __importDefault(require("bs58"));
const provider_1 = require("../../provider");
function isArray(value) {
    return typeof value === "object" && value !== null && Array.isArray(value);
}
function isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
// "wallet_addEthereumChain",
// "solana_signMessage",  There are risks
exports.connectSupportMethods = Object.freeze([
    "personal_sign",
    "sui_signMessage",
    "sui_signPersonalMessage",
    "btc_signMessage",
    "aptos_signMessage",
    "cosmos_signArbitrary",
    "tron_signMessage",
    "tron_signMessageV2",
    "starknet_signMessage",
    "sync_all_addresses"
]);
function creatNotSupportMethodItemReplay(requestParams) {
    let notSupportError = new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
    var errorItem = {
        method: requestParams.method,
        chainId: requestParams.chainId,
        error: {
            code: notSupportError.code,
            message: notSupportError.message
        },
    };
    return errorItem;
}
function isMobileDiscover() {
    return !!(window.okxwallet) && window.okxwallet.mobileDiscoverWallet;
}
function connectMethodsAdaptOldVersion(requestParams, session) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        try {
            (0, core_1.logDebug)("connectMethodsAdaptOldVersion start params :", JSON.stringify(requestParams));
            let callBackParams = {};
            if (requestParams.method === "solana_signMessage") {
                let solAccount = (_a = session.namespaces[core_1.NameSpaceKeySOL]) === null || _a === void 0 ? void 0 : _a.accounts.filter(function (account1) {
                    return account1.startsWith(requestParams.chainId);
                })[0];
                const solAddress = (0, provider_1.fromAccountToAddress)(solAccount);
                if (requestParams.params && solAddress && "message" in requestParams.params) {
                    let realMessage = requestParams.params.message;
                    if (((_b = session.wallet) === null || _b === void 0 ? void 0 : _b.appName) == "OKX Wallet") {
                        let encodeMessage = new TextEncoder().encode(realMessage);
                        realMessage = bs58_1.default.encode(encodeMessage);
                    }
                    requestParams.params = {
                        message: realMessage,
                        "pubkey": solAddress
                    };
                    requestParams.injectParams = requestParams.params;
                    callBackParams = {
                        publicKey: solAddress
                    };
                    (0, core_1.logDebug)("solana_signMessage account and address:", JSON.stringify(solAccount), solAddress);
                    (0, core_1.logDebug)("solana_signMessage callBackParams:", JSON.stringify(callBackParams));
                    return callBackParams;
                }
                else {
                    throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
                }
            }
            else if (requestParams.method === "sui_signMessage" || requestParams.method === "sui_signPersonalMessage") {
                if ("message" in requestParams.params && requestParams.params.message) {
                    let suiMessage = JSON.parse(JSON.stringify(requestParams.params.message));
                    let convertedArray = Object.values(suiMessage);
                    let uint8Array = new Uint8Array(convertedArray);
                    let decoder = new TextDecoder("utf8");
                    let b64encoded = btoa(decoder.decode(uint8Array));
                    requestParams.params = {
                        message: atob(b64encoded),
                    };
                    requestParams.injectParams = {
                        message: uint8Array
                    };
                    console.log("sui_signMessag suiMessagee suiMessageb64:>>>>", JSON.stringify(requestParams.params), b64encoded);
                    if (requestParams.method === "sui_signMessage") {
                        callBackParams = {
                            "messageBytes": b64encoded,
                            "signature": ""
                        };
                    }
                    else if (requestParams.method === "sui_signPersonalMessage") {
                        callBackParams = {
                            "bytes": b64encoded,
                            "signature": ""
                        };
                    }
                    (0, core_1.logDebug)("sui_signMessage/sui_signPersonalMessage callBackParams:", JSON.stringify(callBackParams));
                    return callBackParams;
                }
                else {
                    throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
                }
            }
            else if (requestParams.method === "btc_signMessage") {
                let btcAccounts = (_c = session.namespaces[core_1.NameSpaceKeyBtc]) === null || _c === void 0 ? void 0 : _c.accounts.filter(function (account2) {
                    return account2.startsWith(requestParams.chainId);
                });
                let btcAccount = btcAccounts[0];
                const btcAddress = (0, provider_1.fromAccountToAddress)(btcAccount);
                (0, core_1.logDebug)("btc_signMessage account and address:", JSON.stringify(btcAccount), btcAddress);
                if (btcAddress) {
                    if ("message" in requestParams.params && requestParams.params.message && typeof requestParams.params.message === 'string') {
                        requestParams.params = {
                            from: btcAddress,
                            signStr: requestParams.params.message
                        };
                    }
                    else {
                        throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
                    }
                    requestParams.params["from"] = btcAddress;
                    (0, core_1.logDebug)("btc_signMessage callBackParams:", JSON.stringify(callBackParams));
                    return callBackParams;
                }
                else {
                    throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
                }
            }
            else if (requestParams.method === "aptos_signMessage") {
                let paramData = requestParams.params;
                let aptosAccount = (_d = session.namespaces[core_1.NameSpaceKeyAptos]) === null || _d === void 0 ? void 0 : _d.accounts.filter(function (account3) {
                    return account3.startsWith(requestParams.chainId);
                })[0];
                let aptosAddress = (0, provider_1.fromAccountToAddress)(aptosAccount);
                if (paramData && aptosAddress) {
                    let prefix = "APTOS";
                    let message = "", nonce = "";
                    var fullMessage = prefix;
                    let application = window.location.protocol + "//" + window.location.hostname;
                    if ("address" in paramData && paramData.address) {
                        fullMessage += "\naddress: " + aptosAddress;
                    }
                    if ("application" in paramData && paramData.application) {
                        fullMessage += "\napplication: " + application;
                    }
                    let aptosChainId = 1;
                    if ("chainId" in paramData && paramData.chainId) {
                        if (paramData.chainId == "aptos:mainnet") {
                            aptosChainId = 1;
                        }
                        else if (paramData.chainId == "movement:testnet") {
                            aptosChainId = 2;
                        }
                        fullMessage += "\nchainId: " + aptosChainId;
                    }
                    if ("message" in paramData) {
                        fullMessage += "\nmessage: " + paramData.message;
                        message = paramData.message;
                    }
                    if ("nonce" in paramData) {
                        fullMessage += "\nnonce: " + paramData.nonce;
                        nonce = paramData.nonce;
                    }
                    const utf8Array = new TextEncoder().encode(fullMessage);
                    const hex = Array.from(utf8Array)
                        .map(byte => byte.toString(16).padStart(2, "0"))
                        .join("");
                    requestParams.params = {
                        "message": hex,
                    };
                    requestParams.injectParams = paramData;
                    (0, core_1.logDebug)("aptos_signMessage requestParams:", JSON.stringify(requestParams));
                    callBackParams = {
                        address: aptosAddress,
                        application: application,
                        chainId: aptosChainId,
                        fullMessage: fullMessage,
                        message: message,
                        nonce: nonce,
                        prefix: prefix,
                        signature: "",
                    };
                    (0, core_1.logDebug)("aptos_signMessage callBackParams:", JSON.stringify(callBackParams));
                    return callBackParams;
                }
                else {
                    throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
                }
            }
            else if (requestParams.method === "cosmos_signArbitrary") {
                let cosmosAccount = (_e = session === null || session === void 0 ? void 0 : session.namespaces[core_1.NameSpaceKeyCosmos]) === null || _e === void 0 ? void 0 : _e.accounts.filter(function (account_cosmos) {
                    return account_cosmos.startsWith(requestParams.chainId);
                })[0];
                const cosmosAddress = (0, provider_1.fromAccountToAddress)(cosmosAccount);
                let cosmosData = requestParams.params["message"];
                const cosmosBase64Encoded = btoa(cosmosData);
                (0, core_1.logDebug)("cosmos_signArbitrary account and address:", JSON.stringify(cosmosAccount), cosmosAddress);
                (0, core_1.logDebug)("cosmos_signArbitrary cosmosBase64Encoded:", cosmosBase64Encoded);
                if (cosmosData && cosmosAddress) {
                    const signDoc = {
                        chain_id: "",
                        account_number: "0",
                        sequence: "0",
                        fee: {
                            gas: "0",
                            amount: []
                        },
                        msgs: [{
                                "type": "sign/MsgSignData",
                                "value": {
                                    "signer": cosmosAddress,
                                    "data": cosmosBase64Encoded
                                }
                            }],
                        memo: ""
                    };
                    requestParams.params = {
                        "signer": cosmosAddress,
                        "chain_id": requestParams.chainId.split(":")[1],
                        "data": signDoc
                    };
                    (0, core_1.logDebug)("cosmos_signArbitrary callBackParams:", JSON.stringify(callBackParams));
                    return callBackParams;
                }
                else {
                    throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
                }
            }
            (0, core_1.logDebug)("sol_handleSignatureData end params:", JSON.stringify(requestParams));
        }
        catch (error) {
            throw error;
        }
    });
}
function connectMethodsResponseUpdate(session, requestParams) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        try {
            if (session.signResponse) {
                (0, core_1.logDebug)("connectMethodsResponseUpdate signResponse:", JSON.stringify(session.signResponse));
                (0, core_1.logDebug)("connectMethodsResponseUpdate session.namespaces:", JSON.stringify(session.namespaces));
                for (const methodItem of session.signResponse) {
                    (0, core_1.logDebug)("connectMethodsResponseUpdate methodItem:", JSON.stringify(methodItem));
                    if ("result" in methodItem) {
                        if (methodItem.method === "solana_signMessage") {
                            let solanaSuccessData = methodItem.result;
                            (0, core_1.logDebug)("solana_signMessage methodItem.chainId:", methodItem.chainId);
                            let account = (_a = session.namespaces[core_1.NameSpaceKeySOL]) === null || _a === void 0 ? void 0 : _a.accounts.filter(function (account) {
                                (0, core_1.logDebug)("solana_signMessage account:", account);
                                return account.startsWith(methodItem.chainId);
                            })[0];
                            (0, core_1.logDebug)("solana_signMessage result account:", solanaSuccessData, account);
                            if (solanaSuccessData && account) {
                                methodItem.result = {
                                    "signature": bs58_1.default.decode(solanaSuccessData),
                                    "publicKey": (0, provider_1.fromAccountToAddress)(account)
                                };
                            }
                        }
                        else if (methodItem.method === "sui_signMessage" || methodItem.method === "sui_signPersonalMessage") {
                            let suiMethod = requestParams.filter(function (requestMethod) {
                                return requestMethod.method === methodItem.method;
                            })[0];
                            if (suiMethod && suiMethod.params && "message" in suiMethod.params) {
                                let suiMessage = suiMethod.params.message;
                                let suiMessageb64 = btoa(suiMessage);
                                console.log("sui_signMessag suiMessagee suiMessageb64:>>>>", suiMessage, suiMessageb64);
                                if (methodItem.method === "sui_signMessage") {
                                    methodItem.result = {
                                        "messageBytes": suiMessageb64,
                                        "signature": methodItem.result
                                    };
                                }
                                else if (methodItem.method === "sui_signPersonalMessage") {
                                    methodItem.result = {
                                        "bytes": suiMessageb64,
                                        "signature": methodItem.result
                                    };
                                }
                            }
                        }
                        else if (methodItem.method === "aptos_signMessage") {
                            methodItem.chainId = (0, core_1.replaceChainIdToChainName)(methodItem.chainId);
                            methodItem.result = JSON.parse(methodItem.result);
                            console.log("aptos_signMessage result methodItem.result before:>>>>", JSON.stringify(methodItem.result));
                            if (methodItem.result && "signature" in methodItem.result) {
                                let aptosSignature = methodItem.result.signature;
                                if (aptosSignature && aptosSignature.startsWith("0x")) {
                                    aptosSignature = aptosSignature.slice(2, aptosSignature.length);
                                    methodItem.result.signature = aptosSignature;
                                }
                            }
                            console.log("aptos_signMessage result methodItem.result after:>>>>", JSON.stringify(methodItem.result));
                        }
                        else if (methodItem.method === "cosmos_signArbitrary") {
                            methodItem.result = JSON.parse(methodItem.result);
                        }
                        else if (methodItem.method == 'starknet_signMessage') {
                            let results = methodItem.result;
                            if (typeof results == 'string') {
                                results = JSON.parse(results);
                            }
                            methodItem.result = [results["signedDataR"], results["signedDataS"]];
                        }
                        else if (methodItem.method == 'sync_all_addresses') {
                            methodItem.result = syncResoonseToRequire(methodItem.result);
                        }
                    }
                }
            }
        }
        catch (error) {
            (0, core_1.logDebug)("connectMethodsResponseUpdate signResponse Error:", JSON.stringify(error));
            throw error;
        }
    });
}
function connectMethodsToConnectWalletMethods(params, requireNameSpace) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            (0, core_1.logDebug)("connectMethodsToConnectWalletMethods requestMethods:", JSON.stringify(params));
            const result = [];
            //TODO  后面需要打开限制
            if (params && params.length > 1) {
                throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connectAndSign/openModalAndSign signRequest only support one data`);
            }
            if (!requireNameSpace && params && params.length > 0) {
                throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `Connect request params error , RequestMethods cannot be added when the NameSpace is empty`);
            }
            // check chianId
            for (const methodItem of params) {
                if (methodItem.method === "aptos_signMessage") { //update chainId
                    methodItem.chainId = (0, core_1.replaceChainNameToChainId)(methodItem.chainId);
                }
                // check chianId
                if (methodItem.method === "wallet_addEthereumChain") {
                    var includeEip155 = requireNameSpace === null || requireNameSpace === void 0 ? void 0 : requireNameSpace.some(space => space.namespace.includes("eip155"));
                    if (!includeEip155) {
                        throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `Connect request params error, When using '${methodItem.method}', the EVM chain needs to be included in the NameSpace`);
                    }
                }
                else if (methodItem.method === "sync_all_addresses") {
                    if ((0, provider_1.syncAddressHostAvailable)()) {
                        methodItem.chainId = "";
                    }
                    else {
                        throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED);
                    }
                }
                else {
                    const includeChain = !!(requireNameSpace === null || requireNameSpace === void 0 ? void 0 : requireNameSpace.some(space => space.chains.some(chain => chain.includes(`${methodItem.chainId}`))));
                    if (!includeChain) {
                        throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `Connect request params error, When using '${methodItem.method}', NameSpace must contain '${methodItem.chainId}'`);
                    }
                }
            }
            for (const item of params) {
                if (!exports.connectSupportMethods.includes(item.method)) {
                    throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connect requestMethods not support method, method: '${item.method}'`);
                }
                if (item.method === "wallet_addEthereumChain") {
                    if (Array.isArray(item.params)) {
                        const paramsArr = item.params;
                        if (paramsArr && paramsArr.length === 1) {
                            const firstParam = paramsArr[0];
                            if (isRecord(firstParam)) {
                                item.params = firstParam;
                            }
                        }
                        else if (paramsArr && paramsArr.length > 1) {
                            throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connect request params only support one data, method: '${item.method}'`);
                        }
                        else {
                            throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connect request params is nil, method: '${item.method}'`);
                        }
                    }
                }
                else if (item.method === "personal_sign") {
                    if (isArray(item.params)) {
                        if (item.params && item.params.length !== 1) {
                            throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connect request params error,  method: '${item.method}' `);
                        }
                        let firstObj = item.params[0];
                        if (firstObj && typeof firstObj === 'string') {
                            item.params = {
                                message: firstObj
                            };
                        }
                        else {
                            throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connect request params is error,  method: '${item.method}' `);
                        }
                    }
                }
                else if (item.method === "sui_signMessage" || item.method === "sui_signPersonalMessage") {
                    if (isRecord(item.params) && 'message' in item.params) {
                        if (item.params.message) {
                            (0, core_1.logDebug)("sui_signMessage item.params.message :", item.params.message);
                            let message = JSON.parse(JSON.stringify(item.params.message));
                            let convertedArray = Object.values(message);
                            let uint8Array = new Uint8Array(convertedArray);
                            let decoder = new TextDecoder("utf8");
                            let b64encoded = btoa(decoder.decode(uint8Array));
                            item.params.message = atob(b64encoded);
                        }
                        else {
                            throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connect request params is error,  method: '${item.method}' `);
                        }
                    }
                    else {
                        throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connect request params is error,  method: '${item.method}' `);
                    }
                }
                else if (item.method === "solana_signMessage") {
                    if (isRecord(item.params) && 'message' in item.params) {
                        if (item.params.message && typeof item.params.message === 'string') {
                            let encodeMessage = new TextEncoder().encode(item.params.message);
                            item.params["bs58Message"] = bs58_1.default.encode(encodeMessage);
                        }
                        else {
                            throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connect request params is error,  method: '${item.method}' `);
                        }
                    }
                    else {
                        throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connect request params is error,  method: '${item.method}' `);
                    }
                }
                else if (item.method === "aptos_signMessage") {
                    if (isRecord(item.params)) {
                        if (item.chainId) {
                            var aptosParams = item.params;
                            var currentURL = window.location.protocol + "//" + window.location.hostname;
                            let signChainId = 1;
                            if (item.chainId === "aptos:637") {
                            }
                            else if (item.chainId === "aptos:70000060") {
                                signChainId = 2;
                            }
                            item.params = {
                                data: aptosParams,
                                applicationUrl: currentURL,
                                prefix: "APTOS",
                                aptosChainId: signChainId
                            };
                        }
                        else {
                            throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connect request params chainId is error,  method: '${item.method}' `);
                        }
                    }
                    else {
                        throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connect request params is error,  method: '${item.method}' `);
                    }
                }
                else if (item.method === "cosmos_signArbitrary") {
                    if (isRecord(item.params)) {
                        if (item.params.message && typeof item.params.message === 'string') {
                            const base64Encoded = btoa(item.params.message);
                            let cosmosChain = item.chainId.split(":")[1];
                            if (cosmosChain) {
                                item.params = {
                                    chain_id: cosmosChain,
                                    data: {
                                        chain_id: "",
                                        account_number: "0",
                                        sequence: "0",
                                        fee: {
                                            gas: "0",
                                            amount: []
                                        },
                                        msgs: [{
                                                "type": "sign/MsgSignData",
                                                "value": {
                                                    "signer": "", //address
                                                    "data": base64Encoded
                                                }
                                            }],
                                        memo: ""
                                    }
                                };
                            }
                            else {
                                throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connect request params chainId is error,  method: '${item.method}' `);
                            }
                        }
                        else {
                            throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connect request params message is error,  method: '${item.method}' `);
                        }
                    }
                    else {
                        throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connect request params is error,  method: '${item.method}' `);
                    }
                }
                else if (item.method == "tron_signMessage") {
                    if (isRecord(item.params)) {
                        if ("message" in item.params && item.params.message && typeof item.params.message === 'string') {
                            item.params.message = stringToHex(item.params.message);
                        }
                        else {
                            throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connect request params is error,  method: '${item.method}' `);
                        }
                    }
                    else {
                        throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connect request params is error,  method: '${item.method}' `);
                    }
                }
                else if (item.method == "btc_signMessage") {
                    if (isRecord(item.params)) {
                        if ("message" in item.params && item.params.message && typeof item.params.message === 'string') {
                            item.params = {
                                signStr: item.params.message
                            };
                        }
                        else {
                            throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connect request params is error,  method: '${item.method}' `);
                        }
                    }
                    else {
                        throw new core_1.OKXConnectError(core_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `connect request params is error,  method: '${item.method}' `);
                    }
                }
                (0, core_1.logDebug)("connectMethodsToConnectWalletMethods item:", JSON.stringify(item));
                result.push(item);
            }
            return result;
        }
        catch (error) {
            throw error;
        }
    });
}
function stringToHex(str) {
    let hex = '';
    for (let i = 0; i < str.length; i++) {
        hex += str.charCodeAt(i).toString(16).padStart(2, '0');
    }
    return hex;
}
function syncResoonseToRequire(responseAddressStr) {
    const allAddress = JSON.parse(responseAddressStr);
    const result = {
        type: allAddress.type,
        isEvm: allAddress.isEvm,
        walletName: allAddress.walletName,
        deriveName: allAddress.deriveName,
        addresses: allAddress.addresses.map((addr) => ({
            coinId: addr.ci,
            address: addr.a && addr.a !== 'null' ? addr.a : allAddress.evmAddress,
        })),
    };
    return result;
}
